import '@archetype-themes/vendors/flickity'
import '@archetype-themes/vendors/flickity-fade'

// document.addEventListener('DOMContentLoaded', () => {
//   document.addEventListener("click", function (e) {
//     const button = e.target.closest(".modell-nested-list__toggle-btns");
//     if (!button) return; // Not a toggle button → exit

//     // e.preventDefault();

//     // Find closest parent with one of the two classes
//     let parentItem = button.closest(".modell-child-item, .sub-child-item");
//     if (!parentItem) return;

//     let currentUL = parentItem.querySelector(":scope > ul");
//     if (!currentUL) return;

//     // If already open → close
//     if (currentUL.classList.contains("active")) {
//       currentUL.classList.remove("active");
//       button.setAttribute("aria-expanded", "false");
//       return;
//     }

//     // Close other ULs at the same level
//     parentItem.parentElement
//       .querySelectorAll(":scope > .modell-child-item > ul.active, :scope > .sub-child-item > ul.active")
//       .forEach(openUL => {
//         openUL.classList.remove("active");

//         // Find toggle button inside corresponding heading
//         let heading = openUL.parentElement.querySelector(
//           ".modell-nested-list__heading .modell-nested-list__toggle-btns"
//         );

//         if (heading) {
//           heading.setAttribute("aria-expanded", "false");
//         }
//       });

//     // Open the clicked item
//     currentUL.classList.add("active");
//     button.setAttribute("aria-expanded", "true");
//   });
// });


setTimeout(()=>{
  const salemethodwrapper = document.querySelector('.custom-salemethodwrapper.salemethodwrapper');
  if(salemethodwrapper){
    const allInputRadio=salemethodwrapper.querySelectorAll('input[type="radio"]');
    if(allInputRadio.length>0){
      allInputRadio.forEach(radio=>{
          const custom_product_wrapper = document.querySelector('.custom-product-selector');
          const inner_input = custom_product_wrapper.querySelector('input[name="search_product-1"]');
          if(custom_product_wrapper){
            console.log(inner_input)
            if(inner_input){
              inner_input.setAttribute('disabled', true);
            }
          }
            radio.addEventListener('change', ()=>{
              const panels = document.querySelector('.panels');
              var panelHeights = '';
              if(panels && panels.getBoundingClientRect().height != null || panels.getBoundingClientRect().height != undefined || panels.getBoundingClientRect().height != ''){
                panelHeights = panels.getBoundingClientRect().height;
              }
                if(radio.checked){
                    const currentSelectedValue = radio.value.toLowerCase();
                    const hiddenradio = document.querySelector('.hide-radio-input-5');
                    if(hiddenradio){
                        const allInputFields = hiddenradio.querySelectorAll('input[type="radio"]');
                        if(allInputFields.length > 0){
                            allInputFields.forEach(input=>{
                                const lowerInputValue = input.value.toLowerCase();
                                if(lowerInputValue == currentSelectedValue){
                                    input.checked = true;
                                }
                            })
                        }
                    }
                    if(currentSelectedValue == 'inzahlungnahme' && inner_input && inner_input != ''){
                      panels.classList.add('is-expanded');
                      panels.style.height = (panelHeights+50+38)+'px';
                      if(custom_product_wrapper) custom_product_wrapper.classList.add('is-visible');
                      if(inner_input && inner_input.hasAttribute('disabled')) inner_input.removeAttribute('disabled');
                    } else {
                      if(panels.classList.contains('is-expanded'))panels.style.height = (panelHeights-50-38)+'px';
                      if(custom_product_wrapper) custom_product_wrapper.classList.remove('is-visible');
                      if(inner_input) inner_input.setAttribute('disabled', true);
                    }
                }
            })
        })
    }
  }
  
  const lastAgesalemethodwrapper = document.querySelector('.custom-reparaturservice.salemethodwrapper');
  if(lastAgesalemethodwrapper){
    const lastAgeallInputRadio=lastAgesalemethodwrapper.querySelectorAll('input[type="radio"]');
    if(lastAgeallInputRadio.length>0){
        lastAgeallInputRadio.forEach(radio=>{
            radio.addEventListener('change', ()=>{
                if(radio.checked){
                    const currentSelectedValue = radio.value.toLowerCase();
                    const hiddenradio = document.querySelector('.hidden-radio-input-last-age');
                    if(hiddenradio){
                        const allInputFields = hiddenradio.querySelectorAll('input[type="radio"]');
                        if(allInputFields.length > 0){
                            allInputFields.forEach(input=>{
                                const lowerInputValue = input.value.toLowerCase();
                                if(lowerInputValue == currentSelectedValue){
                                    input.checked = true;
                                }
                            })
                        }
                    }
                }
            })
        })
    }
  }
}, 2500);



// window.attachFilterPopup = function(){
//   const filterBtn = document.querySelector(".collection-filter__icons .popup-filter-open-button");
//   const popup = document.querySelector(".custom-popup__filter");
//   const closeIcon = document.querySelector(".close-icom");
//   const body = document.body;

//   // Open popup
//   filterBtn.addEventListener("click", function () {
//     popup.classList.add("active");
//     body.classList.add("filter-popup__open");
//   });

//   // Close popup when clicking the close icon
//   closeIcon.addEventListener("click", function () {
//     popup.classList.remove("active");
//     body.classList.remove("filter-popup__open");
//   });

//   // Close popup when clicking outside the popup
//   document.addEventListener("click", function (event) {
//     if (!popup.contains(event.target) && !filterBtn.contains(event.target)) {
//       popup.classList.remove("active");
//       body.classList.remove("filter-popup__open");
//     }
//   });

//   const tabs = document.querySelectorAll(".tabs li");
//   const tabContents = document.querySelectorAll(".tab-content");

//   // Activate the first tab
//   if (tabs.length > 0) {
//     tabs[0].classList.add("active");
//   }

//   // Hide all tab contents
//   tabContents.forEach((content, index) => {
//     content.style.display = index === 0 ? "block" : "none";
//   });

//   // Click function
//   tabs.forEach((tab) => {
//     tab.addEventListener("click", function (event) {
//       event.preventDefault();

//       // Remove active class from all tabs
//       tabs.forEach((t) => t.classList.remove("active"));

//       // Add active class to the clicked tab
//       this.classList.add("active");

//       // Hide all tab contents
//       tabContents.forEach((content) => {
//         content.style.display = "none";
//       });

//       // Get the target tab content
//       const anchor = this.querySelector("span");
//       if (anchor) {
//         const activeTabId = anchor.getAttribute("data-tab-id");
//         const activeTabContent = document.querySelector(`[data-targeted-tab-id="${activeTabId}"]`);
//         if (activeTabContent) {
//           // Show with fade-in effect
//           // activeTabContent.style.opacity = 0;
//           activeTabContent.style.display = "block";

//           // let opacity = 0;
//           // const fadeIn = setInterval(() => {
//           //   opacity += 0.1;
//           //   activeTabContent.style.opacity = opacity;
//           //   if (opacity >= 1) {
//           //     clearInterval(fadeIn);
//           //   }
//           // }, 30);
//         }
//       }
//     });
//   });
// }

// window.attachFilterPopup();

// const main_item_grid_wrapper = document.querySelectorAll(".item-grid");
// if(main_item_grid_wrapper.length > 0){
//   main_item_grid_wrapper.forEach(item_grid => {
//     console.log(item_grid);
//     window.updatedFilterPopup(item_grid);
//   });
// }


document.addEventListener('DOMContentLoaded', function() {
    const carouselElement = document.querySelector('.article-carousel');
    if(!carouselElement) return;
    if (carouselElement) {
      // Initialize Flickity with specific options for better control
      var _flkty = new Flickity(carouselElement, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: false, // Disabled wrap around for better control
        groupCells: true,
        cellSelector: '.article-card', // Explicitly tell Flickity what to treat as cells
        adaptiveHeight: false, // Fixed height for stability
        dragThreshold: 10, // More responsive dragging
        selectedAttraction: 0.2, // Smoother transitions
        friction: 0.8,
        imagesLoaded: true // Wait for images to load before initializing
      });

      // Ensure proper layout after all images are loaded
      _flkty.on('ready', function() {
        carouselElement.style.opacity = 1;
        _flkty.resize(); // Force a resize to ensure proper layout
      });
    }
  });

var wishlistCounter = 0;
var _maxAttempts = 10;
function renderWishlistIconHeader(){
  const wishlist_icon = document.querySelector('.swym-wishlist.header__icon');
  if(wishlist_icon){
    if(wishlist_icon.hasAttribute('data-swym-loaded')){
      wishlist_icon.style.display = '';
      clearInterval(getWishlistInterval);
    } else{
      wishlist_icon.style.display = 'none';
      if (wishlistCounter >= _maxAttempts) {
        clearInterval(getWishlistInterval);        
      } else {
        wishlistCounter++;
        getWishlistInterval = setInterval(renderWishlistIconHeader, 200);
      }
    }
  }
}
var getWishlistInterval = setInterval(renderWishlistIconHeader, 500);

window.updatedFilterPopup = function(main_wrapper){
  const itemGrid = document.querySelector('.item-grid');
  if(document.body.classList.contains("filter-popup__open")) document.body.classList.remove("filter-popup__open");
  if(document.body.classList.contains("mobile-filter-open")) document.body.classList.remove("mobile-filter-open");
  var main_popup_wraper = main_wrapper.querySelector(".js__custom-popup__filter[data-popup-active]");
  if(!main_popup_wraper) return;
  const FilterOpenButton = main_wrapper.querySelector(".popup-filter-open-button.desktopfilterbutton");
  const MobileFilterOpenButton = main_wrapper.querySelector(".popup-filter-open-button.Mobilefilterbutton");
  if(FilterOpenButton){
    FilterOpenButton.removeEventListener("click", function(){
      openPopup(main_popup_wraper);
    });
    FilterOpenButton.addEventListener("click", function(){
      openPopup(main_popup_wraper);
    });
  }
  if(MobileFilterOpenButton){
    MobileFilterOpenButton.removeEventListener("click", function(){
      MobileOpenPopup(main_popup_wraper);
    });
    MobileFilterOpenButton.addEventListener("click", function(){
      MobileOpenPopup(main_popup_wraper);
    });
  }
  const closeIcon = main_popup_wraper.querySelector(".close-icom");
  if(closeIcon){
    closeIcon.removeEventListener("click", function(){
      closePopup(main_popup_wraper);
    });
    closeIcon.addEventListener("click", function(){
      closePopup(main_popup_wraper);
    });
  }

  const allTabList = main_popup_wraper.querySelector(".tabs")?.querySelectorAll("li");
  if(allTabList && allTabList.length > 0){
    allTabList.forEach(tab => {
      tab.addEventListener("click", function(){
        allTabList.forEach(_tab => {
          _tab.classList.remove("active");
        });
        updateTab(tab,main_popup_wraper);
      });
    });
  }
  // Horizontal Topbar
  if(itemGrid){
    const allHorizontalTabsList = itemGrid.querySelectorAll('.js_horizontal_filter_list');
    if(allHorizontalTabsList.length > 0){
      allHorizontalTabsList.forEach(horizontal_list=>{
        horizontal_list.addEventListener('click', (e)=>{
            console.log('horizontal called');
          e.stopPropagation();
          updateHorizontalFilters(horizontal_list, allHorizontalTabsList, itemGrid);
        })
      })
    }

    const popupFilterLists = itemGrid.querySelectorAll('.js_popup_filter_list');
    if(popupFilterLists.length > 0){
      popupFilterLists.forEach(popupFilterList=>{
        const innerInput = popupFilterList.querySelector("input.tag__input");
        if(innerInput){
          innerInput.addEventListener('change', (e)=>{
            updateApplyFilterButton(popupFilterList, main_popup_wraper, popupFilterLists);
          })
        }
        // popupFilterList.addEventListener('click', (e)=>{
        //   e.stopPropagation();
        //   setTimeout(()=>{updateApplyFilterButton(popupFilterList, main_popup_wraper, popupFilterLists)}, 100);
        // })
      })
    }
  }



  const ApplyFilterButton = main_popup_wraper.querySelector(".custom-popup__button");
  if(ApplyFilterButton){
    const _popupFilterLists = itemGrid.querySelectorAll('.js_popup_filter_list');
    ApplyFilterButton.addEventListener('click', (e)=>{
      if(_popupFilterLists.length > 0){
        updateMainFilter(main_popup_wraper, _popupFilterLists, itemGrid);
      }
    })
  }

  const tabs = main_popup_wraper.querySelectorAll('.tabsacc li');
  const tabContents = main_popup_wraper.querySelectorAll('.tabs-acc__inner .tabs-contents');
  const backBtns = main_popup_wraper.querySelectorAll('.tabs-acc__backbtn .backbtn');
  const closeIcons = main_popup_wraper.querySelectorAll('.tabs-acc__backbtn .close-icom');

  // Tabs click logic
  if(tabs.length > 0){
    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const tabId = tab.getAttribute('data-list-tab-id');
        tabs.forEach(item => item.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
        tab.classList.add('active');
        const targetContent = document.querySelector(`[data-list-targeted-tab-id="${tabId}"]`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }

  // Back button (arrow) logic
  if(backBtns.length > 0){
    backBtns.forEach(backBtn => {
      backBtn.addEventListener('click', function () {
        tabs.forEach(item => item.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
      });
    });
  }

  // Close icon logic (X button)
  if(closeIcons.length > 0){
    closeIcons.forEach(closeIcon => {
      closeIcon.addEventListener('click', function () {
        const popup = document.querySelector('.custom-popup__mobilefilter');
        const body = document.body;
  
        // Remove popup and body class
        popup?.classList.remove('active');
        body.classList.remove('mobile-filter-open');
  
        // Remove active tab and content
        tabs.forEach(item => item.classList.remove('active'));
        tabContents.forEach(content => content.classList.remove('active'));
      });
    });
  }
}

function updateHorizontalFilters(horizontal_list, allHorizontalTabsList, itemGrid){
  const paramName = horizontal_list.getAttribute('data-filter-param-name');
  const filterValue = horizontal_list.getAttribute('data-filter-value');
  const getHorizontalFilterEle =  itemGrid.querySelector('.js_beliebte-kategorien_filter');
  if(getHorizontalFilterEle){
    const getSelectedInputEle = getHorizontalFilterEle.querySelector(`input.tag__input[name="${paramName}"][value="${filterValue}"]`);
    if(getSelectedInputEle){
      getSelectedInputEle.click();
    }
  }
}

function updateApplyFilterButton(popupFilterList, main_popup_wraper, popupFilterLists){
  console.log('input change called..');
  const parentLi = popupFilterList.parentNode;
  if(parentLi){
    if(parentLi.classList.contains("tag--active")){
      parentLi.classList.remove("tag--active");
    }else{
      parentLi.classList.add("tag--active");
    }
  }
  const ApplyFilterButton = main_popup_wraper.querySelector(".custom-popup__button")?.querySelector("button");
  if(popupFilterLists.length > 0){
    const allCheckedInputSize = Array.from(popupFilterLists).filter(list=>{
      const innerInput = list.querySelector("input.tag__input");
      return innerInput?.checked;
    });
    if(allCheckedInputSize.length > 0){
      ApplyFilterButton.removeAttribute("disabled");
    }else{
      ApplyFilterButton.setAttribute("disabled", true);
    }
  }
}

function updateMainFilter(main_popup_wraper, _popupFilterLists, itemGrid){
  const checkedInputsArray = [];
  
  _popupFilterLists.forEach(filterList => {
    const parentLi = filterList.parentNode;
    if(parentLi.classList.contains("tag--active")){
      const checkedInputs = filterList.querySelectorAll('input.tag__input:checked');
      checkedInputs.forEach(input => {
        checkedInputsArray.push(input);
      });
    }
  });

  const popupFilterPriceRange = itemGrid.querySelector('popup-price-range');
  if(popupFilterPriceRange){
    const minPriceInput = popupFilterPriceRange.querySelector('.price-range__input-min');
    const maxPriceInput = popupFilterPriceRange.querySelector('.price-range__input-max');
    if(minPriceInput && maxPriceInput){
      checkedInputsArray.push(minPriceInput); 
      checkedInputsArray.push(maxPriceInput); 
    }
  }
  if(checkedInputsArray.length > 0){
    callMainFilter(checkedInputsArray, itemGrid);
  }
}

function callMainFilter(checkedInputsArray, itemGrid){

  const mainFilter = itemGrid.querySelector('#CollectionSidebar');
  if(mainFilter && checkedInputsArray.length > 0){
    
    const searchParams = new URLSearchParams();
    
    checkedInputsArray.forEach(input => {
      const name = input.getAttribute('name');
      const value = input.getAttribute('value');
      searchParams.append(name, value);
    });
    if(itemGrid.querySelector(".js__custom-popup__filter")) closePopup(itemGrid.querySelector(".js__custom-popup__filter"));
    itemGrid.startLoading();
    itemGrid.renderCollectionPage(searchParams)
  }
}

function openPopup(main_popup_wraper){
  main_popup_wraper.classList.add("active");
  document.body.classList.add("filter-popup__open");
}

function MobileOpenPopup(main_popup_wraper){
  main_popup_wraper.classList.add("active");
  document.body.classList.add("mobile-filter-open");
}

function closePopup(main_popup_wraper){
  main_popup_wraper.classList.remove("active");
  document.body.classList.remove("filter-popup__open", "mobile-filter-open");
}

function updateTab(tab,main_popup_wraper){
  tab.classList.add("active");
  const tabTabId = tab.querySelector(".tab-link")?.getAttribute("data-tab-id");
  const tabContents = main_popup_wraper.querySelectorAll('[data-targeted-tab-id]');
  if(tabContents.length > 0){
    tabContents.forEach(tabContent => {
      const targetedTabId = tabContent.getAttribute("data-targeted-tab-id");
      if(targetedTabId === tabTabId){
        tabContent.removeAttribute('hidden');
      }else{
        tabContent.setAttribute('hidden', true);
      }
    })
  }
}

window.updateActivePopupFilter = function (){
  const DesktopFilterPopup = document.querySelector('.custom-popup__filter.js__custom-popup__filter');
  const MobileFilterPopup = document.querySelector('.custom-popup__mobilefilter.js__custom-popup__filter');
  if(DesktopFilterPopup || MobileFilterPopup){
    if(window.innerWidth < 769){
      MobileFilterPopup.setAttribute('data-popup-active', true);
      DesktopFilterPopup.removeAttribute('data-popup-active');
    } else{
      MobileFilterPopup.removeAttribute('data-popup-active');
      DesktopFilterPopup.setAttribute('data-popup-active', true);
    }
  }
}

window.addEventListener('resize', window.updateActivePopupFilter);

document.addEventListener('DOMContentLoaded', function () {
    const openButton = document.querySelector('.popup-filter-open-button.Mobilefilterbutton');
    const closeButton = document.querySelector('.custom-popup__mobilefilter .close-icom');
    const popup = document.querySelector('.custom-popup__mobilefilter');
    const body = document.body;

    if (openButton){
      openButton.addEventListener('click', function () {
        popup.classList.add('active');
        body.classList.add('mobile-filter-open');
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        popup.classList.remove('active');
        body.classList.remove('mobile-filter-open');
      });
    }
  });
  
 document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tabsacc li');
  const tabContents = document.querySelectorAll('.tabs-acc__inner .tabs-contents');
  const backBtns = document.querySelectorAll('.tabs-acc__backbtn .backbtn');
  const closeIcons = document.querySelectorAll('.tabs-acc__backbtn .close-icom');

  // Tabs click logic
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const tabId = tab.getAttribute('data-list-tab-id');
      tabs.forEach(item => item.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      tab.classList.add('active');
      const targetContent = document.querySelector(`[data-list-targeted-tab-id="${tabId}"]`);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });

  // Back button (arrow) logic
  backBtns.forEach(backBtn => {
    backBtn.addEventListener('click', function () {
      tabs.forEach(item => item.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
    });
  });

  // Close icon logic (X button)
  closeIcons.forEach(closeIcon => {
    closeIcon.addEventListener('click', function () {
      const popup = document.querySelector('.custom-popup__mobilefilter');
      const body = document.body;

      // Remove popup and body class
      popup?.classList.remove('active');
      body.classList.remove('mobile-filter-open');

      // Remove active tab and content
      tabs.forEach(item => item.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
    });
  });
});




// View 360 Popup start here 
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".view360__popup button");
  const popup = document.querySelector(".custom360view__popup");
  const closeBtn = document.querySelector(".custom360closeicon");
  const body = document.body;
  const iframe = popup?.querySelector("iframe");

  if (!iframe) return;

  const originalSrc = iframe.src;

  // Extract video ID
  const videoIdMatch = originalSrc.match(/embed\/([^?]+)/);
  const videoId = videoIdMatch ? videoIdMatch[1] : "";

  // Open Popup
  openBtn.addEventListener("click", function () {
    body.classList.add("view360-popup__open");
    popup.classList.add("active");

    iframe.src =
      originalSrc +
      (originalSrc.includes("?") ? "&" : "?") +
      `autoplay=1&mute=1&loop=1&playlist=${videoId}`;
  });

  // Close Function
  function closePopup() {
    body.classList.remove("view360-popup__open");
    popup.classList.remove("active");
    iframe.src = originalSrc;
  }

  closeBtn.addEventListener("click", closePopup);

  document.addEventListener("click", function (e) {
    if (popup.classList.contains("active") && !popup.contains(e.target) && !openBtn.contains(e.target)) {
      closePopup();
    }
  });
});



// View 360 Popup End here 





window.addEventListener("scroll", function () {
    const scrollTop = window.scrollY; 
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    if (scrollPercent >= 5) {
        document.body.classList.add("chat-app__scroll");
    } else {
        document.body.classList.remove("chat-app__scroll");
    }
});
